import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Button, Flex, H4, IconButton, P } from 'design-system-web';

import { FONT_AWESOME_REGULAR } from 'lane-shared/helpers/constants/icons';

import styles from './DisableCustomFieldConfirmationModal.scss';

type DisableCustomFieldConfirmationModalProps = {
  isOpen: boolean;
  onConfirm: () => void | Promise<void>;
  onCancel: () => void;
};

export function DisableCustomFieldConfirmationModal({
  isOpen,
  onConfirm,
  onCancel,
}: DisableCustomFieldConfirmationModalProps): React.ReactElement {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      size="small"
      includeHeader={false}
      disableContentPadding
      className={styles.confirmationModal}
      testId="disableCustomFieldConfirmationModal"
    >
      <Flex className={styles.confirmationModalHeader} justify="space-between" align="center">
        <H4>{t('web.admin.visitorManagement.customField.toggle.confirmation.title')}</H4>
        <IconButton
          type={FONT_AWESOME_REGULAR}
          icon="times"
          data-test="closeButton"
          size="medium"
          onClick={onCancel}
        />
      </Flex>

      <div className={styles.confirmationModalBody}>
        <P className={styles.confirmationModalQuestion}>
          {t('web.admin.visitorManagement.customField.toggle.confirmation.question')}
        </P>
        <P className={styles.confirmationModalDescription}>
          {t('web.admin.visitorManagement.customField.toggle.confirmation.description')}
        </P>
      </div>

      <div className={styles.confirmationModalFooter}>
        <Button variant="primary" onClick={onConfirm} data-test="confirmButton">
          {t('web.admin.visitorManagement.customField.toggle.confirmation.confirm')}
        </Button>
        <Button variant="secondary" onClick={onCancel} data-test="cancelButton">
          {t('web.admin.visitorManagement.customField.modal.cancel')}
        </Button>
      </div>
    </Modal>
  );
}
